export default {
  order: {
    title: "Замовлення",
    pickupDate: "Дата подачі",
    pickup: "Місце подачі",
    dropoff: "Місце призначення",
    passenger: "Пасажир",
    comment: "Коментар",
    vehicle: "Транспорт",
    chauffeur: "Водій",
    passengersCount: "Пасажири",
    childSeats: "Дитячі крісла",
    flightNumber: "Номер рейсу",
    nameSign: "Табличка з іменем",
    speaks: "Розмовляє",
    call: "Зателефонувати",
    licensePlate: "Номерний знак",
    category: "Категорія",
    status: {
      new: "Очікування підтвердження",
      confirmed: "Замовлення підтверджено",
      on_my_way: "Водій у дорозі",
      at_the_location: "Водій на місці",
      pob: "Пасажир у машині",
      clear: "Замовлення завершено",
      no_show: "Пасажир не з'явився",
      canceled: "Замовлення скасовано"
    },
    statusDescriptions: {
      new: "Замовлення очікує підтвердження постачальником",
      confirmed: "Постачальник підтвердив замовлення, очікування початку",
      on_my_way: "Водій у дорозі до місця подачі",
      at_the_location: "Водій прибув і чекає пасажира",
      pob: "Пасажир сів у машину, у дорозі до місця призначення",
      clear: "Замовлення успішно завершено",
      no_show: "Пасажир не з'явився в місці подачі",
      canceled: "Замовлення скасовано"
    },
    messages: {
      noChauffeurAssigned: "Ваш водій ще не призначений",
      detailsWillAppear: "Деталі з'являться тут після призначення",
      unknown: "Невідомо",
      started: "Розпочато",
      awaitingAssignment: "Очікування призначення"
    },
    childSeatsTypes: {
      child_01: "Люлька (6 місяців)",
      child_02: "Дитяче крісло (0-7 років)",
      child_03: "Бустер (6-12 років)"
    },
    distance: "{distance} км",
    review: "Оцініть свою поїздку",
    review_status: {
      perfect: 'Ідеально',
      good: 'Добре',
      average: 'Задовільно',
      bad: 'Погано',
      terrible: 'Жахливо'
    }
  },
  common: {
    save: "Зберегти",
    cancel: "Скасувати",
    loading: "Завантаження...",
    error: "Помилка"
  }
}